
import { Venn_Grp } from './venn_grp';
import { Venn_Grp_AttrsUtil } from '../../utils/venn_grp_attrs.util';
import { Venn_Grp_Attr } from './venn_grp_attr';

export class VennGroup {
    venn_Grp: Venn_Grp;
    venn_Grp_Attrs: Array<Venn_Grp_Attr>;

    constructor() {
        this.setDefault();
    }

    setDefault() {
        this.venn_Grp = new Venn_Grp();
        this.venn_Grp_Attrs = new Array();
    }

    static parse(vennGroupTmp: any): VennGroup {
        let vennGroup: VennGroup = new VennGroup();
        vennGroup.copyFrom(vennGroupTmp as VennGroup);
        return vennGroup;
    }

    copy(): VennGroup {
        let vennGroupTmp: VennGroup = new VennGroup();

        vennGroupTmp.venn_Grp = this.venn_Grp.copy();
        vennGroupTmp.venn_Grp_Attrs = Venn_Grp_AttrsUtil.getInstance().copy(this.venn_Grp_Attrs);

        return vennGroupTmp;
    }

    copyFrom(vennGroupTmp: VennGroup): void {
        this.venn_Grp.copyFrom(vennGroupTmp.venn_Grp);
        Venn_Grp_AttrsUtil.getInstance().copyFrom(this.venn_Grp_Attrs, vennGroupTmp.venn_Grp_Attrs);
    }

    compare(vennGroupTmp: VennGroup) {
        let vennGroupString: string = toString();
        let vennGroupTmpString: string = vennGroupTmp.toString();

        if (vennGroupString != vennGroupTmpString) {
            return vennGroupString + ',' + vennGroupTmpString
        }

        return '';
    }

    toString(): string {
        return "VennGroup [ venn_Grp" + this.venn_Grp.toString() +
            ", venn_Grp_Attrs=" + Venn_Grp_AttrsUtil.getInstance().toString(this.venn_Grp_Attrs) + ",]";
    }
}